import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import React from "react";


export const UserApproveModal = ({
                                     isApproveModalOpen,
                                     handleApproveModalClose,
                                     handleApproveConfirm,
                                     selectedUser
                                 }) => {
    return (
        <Modal isOpen={isApproveModalOpen} onClose={handleApproveModalClose}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Confirm Delete</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    Are you sure you want to approve this user ?
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="green" mr={3} onClick={() => handleApproveConfirm(selectedUser)}>
                        Approve
                    </Button>
                    <Button variant="ghost" onClick={handleApproveModalClose}>
                        Cancel
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}